module.exports = __webpack_public_path__ + "Flag-398.a7c0f4480111954c120939fa2f6290dd.svg";